export default __webpack_public_path__ + "static/bnr_shoplist-a5ae54fe6bbf2941aeab67294164da08.jpg";